import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { WpsImageSvg } from './WpsImageSvg'

export const WpsImageIcon = (props: PropsWithoutRef<IconBaseProps>) => {
  return <Icon component={WpsImageSvg} {...props} />
}
